export const RESET = "Restaurar datos";
export const SHORT_RESET = "Reset";
export const FINALIZE = "Finalizar";
